export const apiWrapper = async ({ fetch, url, options = {} }) => {
  return await new Promise((resolve, reject) => {
    const apiFn = async () => {
      try {
        const response = await fetch(url, options)
        const jsonData = await response.json()
        if (jsonData.error) {
          reject(jsonData.error)
        } else {
          resolve(jsonData)
        }
      } catch(e) {
        reject(e)
      }
    }
    apiFn();
  })
}

export const objectToQueryString = (obj) => {
  const params = new URLSearchParams();
  Object.entries(obj).forEach(([key, value]) => {
    // Do this so zeros are potentially valid as a parameter
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, value);
    }
  });
  const queryString = params.toString();
  return queryString ? `?${queryString}` : '';
};